type Props = {
  icon: React.ReactChild;
  text: string;
  color?: string;
};

const Notification = ({ icon, text, color = '#F81E1E' }: Props) => (
  <div
    className={`rounded-[12px] 
  px-6 py-4 
  flex items-center fixed top-[60px] sm:items-baseline
  -translate-x-[50%] -translate-y-[50%] left-1/2 top-1/2
  z-[50] flex-nowrap whitespace-nowrap max-h-[54px] text-white
  sm:px-4 sm:py-2 sm:text-sm sm:leading-sm sm:max-h-fit sm:w-[90%]
  sm:justify-center
  sm:whitespace-normal
  `}
    style={{ backgroundColor: color }}
  >
    {icon}
    <p className='ml-[6px] text-lg leading-lg sm:text-center'>{text}</p>
  </div>
);

export { Notification };
